import React from 'react';
import { bool, string, func } from 'prop-types';

import MenuSection from './MenuSection';
import MenuItem from './MenuItem';
import { SCMenu, CancelButton, LogoutButton } from './styles';
import { redirectToLoginPage } from '../../services/initiation';

Menu.propTypes = {
  open: bool.isRequired,
  showMember2: bool.isRequired,
  showApartment2: bool.isRequired,
  member1Status: string,
  member2Status: string,
  apartment1Status: string,
  apartment2Status: string,
  details1Status: string,
  swapReasonStatus: string,
  minUc: string,
  proofOfId: string,
  incomeBase: string,
  rentalAgreement: string,
  rentalBase: string,
  LBControl: string,
  sign: string,
  inactivateApplication: func.isRequired,
  applicationStatus: string.isRequired,
};

Menu.defaultProps = {
  member1Status: null,
  member2Status: null,
  apartment1Status: null,
  apartment2Status: null,
  details1Status: null,
  swapReasonStatus: null,
  minUc: null,
  proofOfId: null,
  incomeBase: null,
  rentalAgreement: null,
  rentalBase: null,
  LBControl: null,
  sign: null,
};

function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;domain=.lagenhetsbyte.se';
}

function Menu(props) {
  const hideCancel =
    props.applicationStatus === 'SENT' ||
    props.applicationStatus === 'AWAITING_SIGN' ||
    props.applicationStatus === 'READY';

  const logOut = () => {
    localStorage.clear();
    eraseCookie('refresh_token');
    eraseCookie('refreshToken');
    eraseCookie('JWAUTH');

    redirectToLoginPage();
  };

  return (
    <SCMenu open={props.open}>
      <MenuSection label="Grundläggande">
        <MenuItem
          title="Bytespart"
          status={props.member1Status}
          to="/bytespart"
        />
        {props.showMember2 && (
          <MenuItem
            title="Bytespart 2"
            status={props.member2Status}
            to="/bytespart/2"
          />
        )}
        <MenuItem
          error
          title="Lägenhet"
          status={props.apartment1Status}
          to="/lagenhet"
        />
        {props.showApartment2 && (
          <MenuItem
            title="Lägenhet 2"
            status={props.apartment2Status}
            to="/lagenhet/2"
          />
        )}
        <MenuItem
          title="Skäl till bytet"
          status={props.swapReasonStatus}
          to="/skal-till-bytet"
        />
        <MenuItem
          title="Bytesdetaljer"
          status={props.details1Status}
          to="/bytesdetaljer"
        />
      </MenuSection>

      <MenuSection label="Dokument">
        <MenuItem title="Min UC" status={props.minUc} to="/ladda-upp/minuc" />
        <MenuItem
          title="Familjebevis"
          status={props.proofOfId}
          to="/ladda-upp/personbevis"
        />
        <MenuItem
          title="Inkomstunderlag"
          status={props.incomeBase}
          to="/ladda-upp/inkomstbevis"
        />
        <MenuItem
          title="Hyresavtal"
          status={props.rentalAgreement}
          to="/ladda-upp/hyresavtal"
        />
        <MenuItem
          title="Aktuell hyra"
          status={props.rentalBase}
          to="/ladda-upp/hyresbevis"
        />
      </MenuSection>

      <MenuSection label="Granskning">
        <MenuItem
          title={
            window.isBytesansokanSe
              ? 'Bytesansökan granskar'
              : 'Lägenhetsbyte granskar'
          }
          status={props.LBControl}
          disabled={props.LBControl === null}
          to={window.isBytesansokanSe ? '/granskar' : '/lagenhetsbyte-granskar'}
        />

        <MenuItem
          title="Signering med Bank-ID"
          status={props.sign}
          disabled={props.sign === null}
          to="/signering"
        />

        <MenuItem
          title="Hanteras hos hyresvärd"
          status={props.sign === 'APPROVED' ? 'UPDATED' : null}
          disabled={props.sign !== 'APPROVED'}
          to="/hyresvard-hanterar"
        />
      </MenuSection>

      <MenuSection>
        <LogoutButton noMargin onClick={logOut}>
          Logga ut
        </LogoutButton>
      </MenuSection>

      {!hideCancel && (
        <MenuSection>
          <CancelButton onClick={props.inactivateApplication}>
            Avbryt ansökan
          </CancelButton>
        </MenuSection>
      )}
    </SCMenu>
  );
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js